<template>
  <div
    class="favorite-selector selected"
    v-if="favoriteLocation && favoriteLocation.c_locationSlug === slug"
  >
    <img
      :src="`${assetPath}images/icons/star-icon-selected.svg`"
      alt="Selected favorite store icon"
    />
    <span> your favorite</span>
  </div>
  <div class="favorite-selector" @click="setFavoriteLocation(location)" v-else>
    <img
      :src="`${assetPath}images/icons/star-icon.svg`"
      alt="Select as your favorite store icon"
    />
    <span> make favorite</span>
  </div>
</template>
<script>
import { store } from '@/store';
import {toggleLocationPanel} from '../../../../components/locationPanel';

export default {
  name: 'FavoriteLocation',
  props: ['location'],
  data() {
    return {
      favoriteLocation: null,
      assetPath: store.assetPath(),
      perchPath: store.perchPath(),
      slug: this.$route.params.slug,
    };
  },
  mounted() {
    //Step 1.  Retrieve user's favorite location.
    if (localStorage && localStorage.getItem('favoriteLocation')) {
      try {
        this.favoriteLocation = JSON.parse(
          localStorage.getItem('favoriteLocation')
        );
        //Step 2.  If favorite location is set, but the favorite location banner isn't populated, initiate it.
        if (!document.querySelector('c-location-banner--panel')) {
          toggleLocationPanel(this.favoriteLocation);
        }
        return this.favoriteLocation;
      } catch (error) {}
    } else {
      //Step 3.  If the user does not have a favorite location set, be sure to init the panel.  Similiar logic in @/views/Home.vue
      toggleLocationPanel();
    }
    // this.favoriteLocation = store.getInitialFavoriteLocation();
  },
  methods: {
    setFavoriteLocation(location) {
      store.setFavoriteLocation(location);
      this.favoriteLocation = store.getFavoriteLocation();
    },
  },
};
</script>
